import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

const tubeHeight = em(320)
const tubeHeightMd = em(420)

export const ChipWrapper = styled.div`
  position: relative;
  height: ${tubeHeight};

  ${p => p.theme.mq.upMd} {
    height: ${tubeHeightMd};
  }
`

export const ChipImg = styled(DynamicImage)`
  position: absolute;
  left: 0;
  top: 0;
  width: ${em(250)};
  max-width: 100%;
  height: auto;
  ${p => p.theme.mq.upMd} {
    top: -28%;
    left: 50%;
    width: 100%;
    max-width: ${em(320)};
    transform: translateX(-50%);
  }
`
